<app-dialog-banner [dialogRef]="dialogRef" text="Purchase Documents" i18n-text></app-dialog-banner>

<mat-dialog-content class="mat-typography" style="max-width: 700px; min-width: 500px">

    @switch (phase) {

        @case ('loading') {
            <p i18n>Looking up the purchase documents for {{cycle.name}}...</p>
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        }

        @case ('confirm') {
            <p i18n>
                {{cycle.name}} has {{transactionCount | number}} purchase transactions, with
                {{documents.length | number}} documents attached to them.
            </p>

            @if (missing.length > 0) {
                <p style="display: flex; align-items: center; gap: 8px">
                    <mat-icon style="color: red; flex: 0 0 24px">warning</mat-icon>
                    <span i18n>{{missing.length | number}} transactions have no document attached.
                        They are still listed in the contents file, marked NO DOCUMENT.</span>
                </p>
            }

            <p i18n>
                You will be asked to choose a folder. We create <b>{{targetFolderName}}</b> inside
                it, holding a folder per supplier under purchases, purchaseCredits and
                cashPurchases - {{folderCount | number}} folders in all - and a _contents.csv
                listing every transaction and the documents expected for it.
            </p>

            <p i18n>Leave this window open until it finishes.</p>
        }

        @case ('running') {
            <p i18n>Saving {{written + failed.length | number}} of {{documents.length | number}}</p>
            <mat-progress-bar mode="determinate" [value]="progress"></mat-progress-bar>
            <p style="font-size: small; word-break: break-all; min-height: 2.5em">{{currentFile}}</p>
            @if (failed.length > 0) {
                <p style="color: red" i18n>{{failed.length | number}} could not be saved so far.</p>
            }
            <p i18n>Please do not close this window or navigate away.</p>
        }

        @case ('done') {
            @if (failed.length === 0) {
                <p style="display: flex; align-items: center; gap: 8px">
                    <mat-icon style="color: green; flex: 0 0 24px">check_circle</mat-icon>
                    <span i18n>{{written | number}} documents saved, along with _contents.csv.</span>
                </p>
                <p i18n>They are in <b>{{folderName}}</b>, inside the <b>{{pickedName}}</b> folder
                    you chose, under purchases, purchaseCredits and cashPurchases.</p>
            } @else {
                <p style="display: flex; align-items: center; gap: 8px">
                    <mat-icon style="color: red; flex: 0 0 24px">error</mat-icon>
                    <span i18n>{{written | number}} documents saved,
                        {{failed.length | number}} failed.</span>
                </p>
                <p i18n>What did save is in <b>{{folderName}}</b>, inside the <b>{{pickedName}}</b>
                    folder you chose. The failures are listed in _contents.csv as FAILED - Retry
                    saves just those into the same folder.</p>
            }
            @if (missing.length > 0) {
                <p i18n>{{missing.length | number}} transactions had no document to save - see
                    _contents.csv for which.</p>
            }
        }
    }

</mat-dialog-content>

<mat-dialog-actions align="end">
    @switch (phase) {

        @case ('confirm') {
            <button mat-raised-button mat-dialog-close i18n>Cancel</button>
            <button mat-raised-button color="primary" (click)="start()" [disabled]="rows.length === 0"
                data-save-button i18n>Choose Folder and Save</button>
        }

        @case ('done') {
            @if (failed.length > 0) {
                <button mat-raised-button color="primary" (click)="retryFailed()" i18n>Retry Failed</button>
            }
            <button mat-raised-button mat-dialog-close i18n>Close</button>
        }
    }
</mat-dialog-actions>
